/* Convivium — Ricettario badge
   Shows the saved-recipes count on the header heart (desktop) and on the
   Ricettario tab of the mobile bottom nav, and pulses the icon on save.
   Self-contained: reads localStorage directly so it works on every page,
   with or without ricettario-save.js; listens to its `ricettario:change`
   event when present, and to `storage` for cross-tab consistency. */

(function () {
  'use strict';

  var STORAGE_KEY = 'convivium_saved_recipes';

  function count() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(list) ? list.length : 0;
    } catch (_) {
      return 0;
    }
  }

  function render(pulse) {
    var n = count();
    document.querySelectorAll('[data-ricettario-badge]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;

      if (pulse) {
        var host = el.closest('[data-ricettario-badge-host]');
        if (host) {
          host.classList.remove('ricettario-badge-pulse');
          void host.offsetWidth; /* restart the animation */
          host.classList.add('ricettario-badge-pulse');
        }
      }
    });
  }

  /* Fired by ricettario-save.js on every save/remove */
  document.addEventListener('ricettario:change', function (e) {
    render(!!(e.detail && e.detail.saved));
  });

  /* Another tab changed the list */
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) render(false);
  });

  /* Back/forward-cache restores skip DOMContentLoaded */
  window.addEventListener('pageshow', function () {
    render(false);
  });

  /* Horizon morphs the header section after cart updates, restoring the
     server markup where the badge is empty and [hidden]. Watch for that
     and re-apply the count. render() writes the expected state, so the
     mismatch check below keeps the observer from looping. */
  var observer = new MutationObserver(function () {
    var n = count();
    var text = n > 99 ? '99+' : String(n);
    var stale = false;
    document.querySelectorAll('[data-ricettario-badge]').forEach(function (el) {
      if (el.hidden !== (n === 0) || (n > 0 && el.textContent !== text)) stale = true;
    });
    if (stale) render(false);
  });
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['hidden'],
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { render(false); });
  } else {
    render(false);
  }
})();
